import { render, staticRenderFns } from "./listFormButton.vue?vue&type=template&id=f4856576"
import script from "./listFormButton.vue?vue&type=script&lang=js"
export * from "./listFormButton.vue?vue&type=script&lang=js"
import style0 from "./listFormButton.vue?vue&type=style&index=0&id=f4856576&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports